import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import website from '@/components/website'

import steps from '@/components/website/registerSteps'
import step_one from '@/components/website/registerSteps/step1'
import step_two from '@/components/website/registerSteps/step2'
import step_three from '@/components/website/registerSteps/step3'   
// =============== /consultant =======================
import consultation from '@/components/website/consultant/consultation'
import medicalRecords from '@/components/website/consultant/medical-records'
import singlePost from '@/components/website/consultant/single-post'
import consultHistory from '@/components/website/consultant/consultation-history'
import checkConsultation from '@/components/website/consultant/check-consultaion'
import calendyCalendar from '@/components/website/consultant/calendly-calendar-book'

//================/test-report=========================
import TestReport from '@/components/website/test_report/test-report'
import UploadReport from '@/components/website/test_report/upload-reports'
import AnalyzeReport from '@/components/website/test_report/analyze-report'
import Carttest from '@/components/website/test_report/cart-test'
import overallHealth from '@/components/website/test_report/overall-health'
import Diabetes from '@/components/website/test_report/pre-diabetes'
import qrCodeScan from '@/components/website/test_report/QR-code-screaner'
import registerKit from '@/components/website/test_report/register-kit'
import serumElectrolytes from '@/components/website/test_report/serum-electrolytes'
import UploadTestReport from '@/components/website/test_report/upload-test-reports'

//==================/prescription==========================
import addPrescription from '@/components/website/prescription/add-prescription'
import mannualPrescription from '@/components/website/prescription/Mannual-prescription'
import prescriptionCard from '@/components/website/prescription/prescription-cart'
import prescriptionDrug from '@/components/website/prescription/prescription-drug-interaction'
import prescriptionList from '@/components/website/prescription/prescription-list-saved'
import prescriptionMain from '@/components/website/prescription/prescription-main'
import prescriptionMedicine from '@/components/website/prescription/prescription-medicine-order'
import prescriptionOrder from '@/components/website/prescription/prescription-order-confirm'
import prescriptionProduct from '@/components/website/prescription/prescription-product'
import prescriptionWithMedicine from '@/components/website/prescription/prescription-with-medicine'
import Prescription from '@/components/website/prescription/prescription'
import QRprescription from '@/components/website/prescription/Qr-code-prescription'
import Shoprescription from '@/components/website/prescription/shop-prescription'
import Uploadprescription from '@/components/website/prescription/upload-prescription'

//==================/health-tracker==========================
import healthTracker from '@/components/website/health_tracker/health-tracker'
import sleep from '@/components/website/health_tracker/sleep'
import healthSingleProduct from '@/components/website/health_tracker/health-single-product'
import healthCart from '@/components/website/health_tracker/health-cart'

//==================/recommended-diet==========================
import recommendedDiet from '@/components/website/recommended_diet/recommended-diet'
import recommendedFood from '@/components/website/recommended_diet/recommended-food'
import selectMeals from '@/components/website/recommended_diet/select-meals'
import mealsSingle from '@/components/website/recommended_diet/meals-single'
import groceryList from '@/components/website/recommended_diet/grocery-list'

//==================/nutrition-supppliment==========================
import nutrition from '@/components/website/nutrition/nutrition_suppliment'
import alreadyTakeSuppliment from '@/components/website/nutrition/pages/already-taking-suppliment'
import customSupplimentDetail from '@/components/website/nutrition/pages/custom-suppliment-detail'
import customSupplimentQuestionaries from '@/components/website/nutrition/pages/custom-suppliment-questionaries'
import cartSuppliment from '@/components/website/nutrition/pages/cart-suppliment'
import supplimentProductPage from '@/components/website/nutrition/pages/suppliment-product-page'

//==================/exercise-yoga==========================
import exerciseYoga from '@/components/website/exercise/exercise_yoga'


//===================appointments===========================
import BookAppointment from '@/components/website/appointments/book-appointment'
import MakeAppointment from '@/components/website/appointments/make-appointment'
import StartAppointment from '@/components/website/appointments/start-appointment'
import appointment_list from '@/components/website/appointments/appointment-list'
import appointment_detail from '@/components/website/appointments/appointment-detail'


//====================questionaries==========================
import intakeQuestionaries from '@/components/website/questionaries/intake-questionaries'
import intakeQuestionariesPrev from '@/components/website/questionaries/intake-questionaries-preview'
import intakeQuestionariesQues from '@/components/website/questionaries/intake-questionaries-question'
import SubmitQues from '@/components/website/questionaries/submit-question'


//================checkup====================================

import symptomChecker from '@/components/website/checkup/symptom-checker'
import Checkout from '@/components/website/checkup/checkout'
import checkupDetails from '@/components/website/checkup/Checkup-details'
import drugInteraction from '@/components/website/checkup/drug-interaction-check'
import recommCheckup from '@/components/website/checkup/recommended-checkup'

//==========================dna=====================================
import addDnaProfile from '@/components/website/dna/add-dna-profile'
import connectdnaData from '@/components/website/dna/connect-dna-data'
import connectDna from '@/components/website/dna/connect-dna'
import dnaConnect from '@/components/website/dna/dna-connect'
import dnatestReport from '@/components/website/dna/dna-test-reports'
import dnaSuccess from '@/components/website/dna/dna-uploadSuccess'
import orderDnaKit from '@/components/website/dna/order-dna-kit'

//=======================doctor===================================
import doctorList from '@/components/website/doctor/doctor-list'
import doctorProfile from '@/components/website/doctor/doctor-profile'

//===========================medicines============================

import addMedicine from '@/components/website/medicines/add-medicine'
import Medicines from '@/components/website/medicines/medicines'
import stopMedicinedelivery from '@/components/website/medicines/stop-medicine-delivery'

//===================user==================================
import proUser from '@/components/website/user/upgrade-pro-user'
import orderConfirm from '@/components/website/user/order-confirmed'
import login from '@/components/website/user/login'
import forgot_password from '@/components/website/user/forgot_password'
import ResetPasswordFromHash from '@/components/website/user/ResetPasswordFromHash'
import register from '@/components/website/user/register'
import dashboard from '@/components/website/user/dashboard'
import history_Charts from '@/components/website/history-data/charts'
import NotFound from '@/components/website/shared/page-not-found'

//==================/get_started==========================
import getStarted from '@/components/website/get_started/get_started'

//==================/Profile =========================
import profile from '@/components/website/user/profile'


//==================/Choose Plan membership_plan =========================
import membership_plan from '@/components/website/membership_plan/list'

//==================/change_password =========================
import change_password from '@/components/website/user/change_password'

//==================/TaskAndGoal==========================
import goals_and_actions from '@/components/website/goals_and_actions/goals_and_actions'
import overall_health_data from '@/components/website/overall-health/overall-health-data'
import daily_task from '@/components/website/goals_and_actions/daily_task'


Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'login', component: login },
        { path: '/forgot-password', name: 'forgot_password', component: forgot_password },
        {path: '/forgot/password/:hash',name: 'ResetPasswordFromHash',component: ResetPasswordFromHash},
        { path: '/register', name: 'register', component: register },
        {   path: '/',
            component: website,
            children:[
                {   path: '',
                    component: steps,
                    children:[
                        { path: '/step1', name: 'step_one', component: step_one },
                        { path: '/step2', name: 'step_two', component: step_two },
                        { path: '/step3', name: 'step_three', component: step_three }
                    ],
                },
                // { path: '/dashboard', name: 'dashboard', component: dashboard },
                { path: '/history/:type', name: 'history_Charts', component: history_Charts },
                // =============== /consultant =======================
                { path: '/consultation', name: 'consultation', component: consultation },
                { path: '/medical-records', name: 'medicalRecords', component: medicalRecords },
                { path: '/single-post', name: 'singlePost', component: singlePost },
                { path: '/consultation-history', name: 'consultHistory', component: consultHistory },
                { path: '/check-consultation', name: 'checkConsultation', component: checkConsultation },
                { path: '/calendy-calendar', name: 'calendyCalendar', component: calendyCalendar },

                //================/test-report=========================
                { path: '/test-report', name: 'TestReport', component: TestReport },
                { path: '/upload-reports', name: 'UploadReport', component: UploadReport },
                { path: '/analyze-report', name: 'AnalyzeReport', component: AnalyzeReport },
                { path: '/cart-test', name: 'Carttest', component: Carttest },
                { path: '/overall-health', name: 'overallHealth', component: overallHealth },
                { path: '/pre-diabetes', name: 'Diabetes', component: Diabetes },
                { path: '/QR-code-screaner', name: 'qrCodeScan', component: qrCodeScan },
                { path: '/register-kit', name: 'registerKit', component: registerKit },
                { path: '/serum-electrolytes', name: 'serumElectrolytes', component: serumElectrolytes },
                { path: '/upload-test-reports', name: 'UploadTestReport', component: UploadTestReport },


                //==================/prescription==========================
                { path: '/add-prescription', name: 'addPrescription', component: addPrescription },
                { path: '/mannual-prescription', name: 'mannualPrescription', component: mannualPrescription },
                { path: '/prescription-card', name: 'prescriptionCard', component: prescriptionCard },
                { path: '/prescription-drug', name: 'prescriptionDrug', component: prescriptionDrug },
                { path: '/prescription-list', name: 'prescriptionList', component: prescriptionList },
                { path: '/prescription-main', name: 'prescriptionMain', component: prescriptionMain },
                { path: '/prescription-medicine-order', name: 'prescriptionMedicine', component: prescriptionMedicine },
                { path: '/prescription-order-confirm', name: 'prescriptionOrder', component: prescriptionOrder },
                { path: '/prescription-product', name: 'prescriptionProduct', component: prescriptionProduct },
                { path: '/prescription-with-medicine', name: 'prescriptionWithMedicine', component: prescriptionWithMedicine },
                { path: '/prescription', name: 'Prescription', component: Prescription },
                { path: '/qr-prescription', name: 'QRprescription', component: QRprescription },
                { path: '/shop-prescription', name: 'shopPrescription', component: Shoprescription },
                { path: '/upload-prescription', name: 'Uploadprescription', component: Uploadprescription },

                //===================health-tracker==================================
                { path: '/health-tracker', name: 'healthTracker', component: healthTracker },
                { path: '/sleep', name: 'sleep', component: sleep },
                { path: '/health-single-product', name: 'healthSingleProduct', component: healthSingleProduct },
                { path: '/health-cart', name: 'healthCart', component: healthCart },

                //===================recommended-diet==================================
                { path: '/recommended-diet', name: 'recommendedDiet', component: recommendedDiet },
                { path: '/recommended-food', name: 'recommendedFood', component: recommendedFood },
                { path: '/select-meals', name: 'selectMeals', component: selectMeals },
                { path: '/meals-single', name: 'mealsSingle', component: mealsSingle },
                { path: '/grocery-list', name: 'groceryList', component: groceryList },

                //===================nutriion-suppliments==================================
                { path: '/nutriion-suppliments', name: 'nutrition', component: nutrition },
                { path: '/already-taking-suppliment', name: 'alreadyTakeSuppliment', component: alreadyTakeSuppliment },
                { path: '/custom-suppliment-deatil', name: 'customSupplimentDetail', component: customSupplimentDetail },
                { path: '/custom-suppliment-questionaries', name: 'customSupplimentQuestionaries', component: customSupplimentQuestionaries },
                { path: '/cart-suppliment', name: 'cartSuppliment', component: cartSuppliment },
                { path: '/suppliment-product', name: 'supplimentProductPage', component: supplimentProductPage },
                //===================exercise-yoga==================================
                { path: '/exercise-yoga', name: 'exerciseYoga', component: exerciseYoga },

                //===================user==================================
                { path: '/pro-user', name: 'proUser', component: proUser },
                { path: '/order-confirmed', name: 'orderConfirm', component: orderConfirm },
                //===================appointments===========================
                { path: '/book-appointment', name: 'BookAppointment', component: BookAppointment },
                // { path: '/make-appointment', name: 'MakeAppointment', component: MakeAppointment },
                // { path: '/start-appointment', name: 'StartAppointment', component: StartAppointment },
                { path: '/appointment-list', name: 'appointment_list', component: appointment_list },
                { path: '/appointment-detail', name: 'appointment_detail', component: appointment_detail },

                //====================questionaries==========================
                { path: '/intake-questionaries', name: 'intakeQuestionaries', component: intakeQuestionaries },
                { path: '/intake-questionaries-preview', name: 'intakeQuestionariesPrev', component: intakeQuestionariesPrev },
                { path: '/intake-questionaries-question', name: 'intakeQuestionariesQues', component: intakeQuestionariesQues },
                { path: '/submit-question', name: 'SubmitQues', component: SubmitQues },

                //================checkup====================================
                { path: '/symptom-checker', name: 'symptomChecker', component: symptomChecker },
                { path: '/checkout', name: 'Checkout', component: Checkout },
                { path: '/Checkup-details', name: 'checkupDetails', component: checkupDetails },
                { path: '/drug-interaction', name: 'drugInteraction', component: drugInteraction },
                { path: '/recommended-checkup', name: 'recommCheckup', component: recommCheckup },

                //==========================dna=====================================
                { path: '/add-dna-profile', name: 'addDnaProfile', component: addDnaProfile },
                { path: '/connect-dna-data', name: 'connectdnaData', component: connectdnaData },
                { path: '/connect-dna', name: 'connectDna', component: connectDna },
                { path: '/dna-connect', name: 'dnaConnect', component: dnaConnect },
                { path: '/dna-test-report', name: 'dnatestReport', component: dnatestReport },
                { path: '/dna-success', name: 'dnaSuccess', component: dnaSuccess },
                { path: '/order-dna-kit', name: 'orderDnaKit', component: orderDnaKit },
                //============================doctor====================================
                { path: '/doctor-list', name: 'doctorList', component: doctorList },
                { path: '/doctor-profile', name: 'doctorProfile', component: doctorProfile },
                //===========================medicines============================
                { path: '/add-medicine', name: 'addMedicine', component: addMedicine },
                { path: '/medicine', name: 'Medicines', component: Medicines },
                { path: '/stop-medicine-delivery', name: 'stopMedicinedelivery', component: stopMedicinedelivery },

                //===================get_started==================================
                { path: '/get-started', name: 'getStarted', component: getStarted },


                //===================Profile==================================
                { path: '/profile', name: 'profile', component: profile },

                //=================== membership plan ==================================
                { path: '/membership-plans', name: 'membership_plans', component: membership_plan },

                //===================change_password ==================================
                { path: '/change-password', name: 'change_password', component: change_password },

                //===================Task And Goal==================================
                { path: '/goals-and-actions', name: 'goals_and_actions', component: goals_and_actions },
                { path: '/daily-task', name: 'daily_task', component: daily_task },
                { path: '/overall-health-data', name: 'overall_health_data', component: overall_health_data },
            ]
        },
        { path: '*', name: 'Not Found', component: NotFound }
    ]
})

router.beforeEach((to, from, next) => {
    let userStateVariable = store.state.user
    if(userStateVariable == ''){
        userStateVariable= {}
    }
    //next()
    if (to.name !== 'login' && to.name !== 'register' && to.name !== 'forgot_password' && to.name !== 'ResetPasswordFromHash' && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) {
        next({ name: 'login' })
    }
    else if ((to.name == 'step_one' || to.name == 'step_two' || to.name == 'step_three') && ((userStateVariable != null || 'loggedIn' in userStateVariable) || userStateVariable.loggedIn) && (parseInt(userStateVariable.step) >= 3)){
        next({ name: 'getStarted' })
    }
    else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'login' || to.name == 'register')) next({ name: 'getStarted' })
    else next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js